module.exports = __webpack_public_path__ + "img/dropzone-left.aa261936.png";